module.exports = __webpack_public_path__ + "static/media/icon_download_inverse.440eceaa.svg";